const cmaOps = require('./cmaOperations');

let newArr = null;

module.exports = function (arrayLength, cma_ffs_values, cma_pl_values, cma_bs_values) {

  cma_ffs_values.cma_ffs_2 = cma_pl_values.cma_pl_85;

  // cma_ffs_values.cma_ffs_3
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cmaOps.getValue(cma_bs_values.cma_bs_94[i] - cma_bs_values.cma_bs_94[i-1]);
  }
  cma_ffs_values.cma_ffs_3 = newArr;

  // cma_ffs_values.cma_ffs_4
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cmaOps.getValue(cma_bs_values.cma_bs_41[i] - cma_bs_values.cma_bs_41[i-1]);
  }
  cma_ffs_values.cma_ffs_4 = newArr;

  // cma_ffs_values.cma_ffs_5
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cmaOps.getPositiveValueOnly(cma_bs_values.cma_bs_38[i] - cma_bs_values.cma_bs_38[i-1]);
  }
  cma_ffs_values.cma_ffs_5 = newArr;

  // cma_ffs_values.cma_ffs_6
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cmaOps.getPositiveValueOnly(cma_bs_values.cma_bs_91[i-1] - cma_bs_values.cma_bs_91[i]);
  }
  cma_ffs_values.cma_ffs_6 = newArr;

  // cma_ffs_values.cma_ffs_7
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cmaOps.getPositiveValueOnly(cma_bs_values.cma_bs_112[i-1] - cma_bs_values.cma_bs_112[i] + cma_bs_values.cma_bs_116[i-1] - cma_bs_values.cma_bs_116[i]);
  }
  cma_ffs_values.cma_ffs_7 = newArr;

  // cma_ffs_values.cma_ffs_8
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cmaOps.getPositiveValueOnly((cma_bs_values.cma_bs_56[i] - cma_bs_values.cma_bs_56[i-1]) - (cma_bs_values.cma_bs_41[i] - cma_bs_values.cma_bs_41[i-1]) + cma_bs_values.cma_bs_11[i] - cma_pl_values.cma_pl_85[i]);
  }
  cma_ffs_values.cma_ffs_8 = newArr;

  // cma_ffs_values.cma_ffs_10
  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    const val = cma_pl_values.cma_pl_85[i];
    newArr[i] = (val < 0) ? -val : 0;
  }
  cma_ffs_values.cma_ffs_10 = newArr;

  // cma_ffs_values.cma_ffs_11
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cmaOps.getPositiveValueOnly(cma_bs_values.cma_bs_38[i-1] - cma_bs_values.cma_bs_38[i]);
  }
  cma_ffs_values.cma_ffs_11 = newArr;

  // cma_ffs_values.cma_ffs_12
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cmaOps.getPositiveValueOnly(cma_bs_values.cma_bs_91[i] - cma_bs_values.cma_bs_91[i-1]);
  }
  cma_ffs_values.cma_ffs_12 = newArr;

  // cma_ffs_values.cma_ffs_13
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cmaOps.getPositiveValueOnly(cma_bs_values.cma_bs_112[i] - cma_bs_values.cma_bs_112[i-1] + cma_bs_values.cma_bs_116[i] - cma_bs_values.cma_bs_116[i-1]);
  }
  cma_ffs_values.cma_ffs_13 = newArr;

  cma_ffs_values.cma_ffs_14 = cma_pl_values.cma_pl_86;

  // cma_ffs_values.cma_ffs_15
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cmaOps.getPositiveValueOnly((cma_bs_values.cma_bs_56[i-1] - cma_bs_values.cma_bs_56[i]) + (cma_bs_values.cma_bs_41[i] - cma_bs_values.cma_bs_41[i-1]) - cma_bs_values.cma_bs_11[i] + cma_pl_values.cma_pl_85[i]);
  }
  cma_ffs_values.cma_ffs_15 = newArr;

  cma_ffs_values.cma_ffs_1 = cmaOps.sum(cma_ffs_values.cma_ffs_2, cma_ffs_values.cma_ffs_3, cma_ffs_values.cma_ffs_4, cma_ffs_values.cma_ffs_5, cma_ffs_values.cma_ffs_6, cma_ffs_values.cma_ffs_7, cma_ffs_values.cma_ffs_8);
  cma_ffs_values.cma_ffs_9 = cmaOps.sum(cma_ffs_values.cma_ffs_10, cma_ffs_values.cma_ffs_11, cma_ffs_values.cma_ffs_12, cma_ffs_values.cma_ffs_13, cma_ffs_values.cma_ffs_14, cma_ffs_values.cma_ffs_15);

  cma_ffs_values.cma_ffs_16 = cmaOps.difference(cma_ffs_values.cma_ffs_1, cma_ffs_values.cma_ffs_9);

  // cma_ffs_values.cma_ffs_17
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_89[i] - cma_bs_values.cma_bs_89[i-1];
  }
  cma_ffs_values.cma_ffs_17 = newArr;

  // cma_ffs_values.cma_ffs_18
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_27[i] - cma_bs_values.cma_bs_27[i-1];
  }
  cma_ffs_values.cma_ffs_18 = newArr;

  // cma_ffs_values.cma_ffs_19
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = (cma_bs_values.cma_bs_89[i] - cma_bs_values.cma_bs_89[i-1]) - (cma_bs_values.cma_bs_27[i] - cma_bs_values.cma_bs_27[i-1]);
  }
  cma_ffs_values.cma_ffs_19 = newArr;

  cma_ffs_values.cma_ffs_20 = cmaOps.difference(cma_ffs_values.cma_ffs_16, cma_ffs_values.cma_ffs_19);

  // cma_ffs_values.cma_ffs_21
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_2[i] - cma_bs_values.cma_bs_2[i-1];
  }
  cma_ffs_values.cma_ffs_21 = newArr;

  // cma_ffs_values.cma_ffs_22
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_pl_values.cma_pl_5[i] - cma_pl_values.cma_pl_5[i-1];
  }
  cma_ffs_values.cma_ffs_22 = newArr;

  // cma_ffs_values.cma_ffs_24
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_71[i] - cma_bs_values.cma_bs_71[i-1];
  }
  cma_ffs_values.cma_ffs_24 = newArr;

  // cma_ffs_values.cma_ffs_25
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_74[i] - cma_bs_values.cma_bs_74[i-1];
  }
  cma_ffs_values.cma_ffs_25 = newArr;

  // cma_ffs_values.cma_ffs_26
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_75[i] - cma_bs_values.cma_bs_75[i-1];
  }
  cma_ffs_values.cma_ffs_26 = newArr;

  // cma_ffs_values.cma_ffs_28
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_66[i] - cma_bs_values.cma_bs_66[i-1];
  }
  cma_ffs_values.cma_ffs_28 = newArr;

  // cma_ffs_values.cma_ffs_29
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_67[i] - cma_bs_values.cma_bs_67[i-1];
  }
  cma_ffs_values.cma_ffs_29 = newArr;

  // cma_ffs_values.cma_ffs_30
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_76[i] - cma_bs_values.cma_bs_76[i-1];
  }
  cma_ffs_values.cma_ffs_30 = newArr;

  // cma_ffs_values.cma_ffs_31
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_bs_values.cma_bs_81[i] - cma_bs_values.cma_bs_81[i-1];
  }
  cma_ffs_values.cma_ffs_31 = newArr;

  cma_ffs_values.cma_ffs_23 = cmaOps.sum(cma_ffs_values.cma_ffs_24, cma_ffs_values.cma_ffs_25, cma_ffs_values.cma_ffs_26, cma_ffs_values.cma_ffs_28, cma_ffs_values.cma_ffs_29, cma_ffs_values.cma_ffs_30, cma_ffs_values.cma_ffs_31);

  return cma_ffs_values;
};



// WEBPACK FOOTER //
// ./src/cma/calculations_FFS.js